var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.link.shown
    ? _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.link.sourceLoaded || _vm.link.type === "link",
              expression: "link.sourceLoaded || link.type === 'link'",
            },
          ],
          ref: "container",
          staticClass: "preview",
          attrs: { dir: "ltr" },
        },
        [
          _c(
            "div",
            {
              ref: "content",
              class: [
                "toggle-content",
                "toggle-type-" + _vm.link.type,
                { opened: _vm.isContentShown },
              ],
            },
            [
              _vm.link.type === "link"
                ? [
                    _vm.link.thumb
                      ? _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.link.sourceLoaded,
                                expression: "link.sourceLoaded",
                              },
                            ],
                            staticClass: "toggle-thumbnail",
                            attrs: {
                              href: _vm.link.link,
                              target: "_blank",
                              rel: "noopener",
                            },
                            on: { click: _vm.onThumbnailClick },
                          },
                          [
                            _c("img", {
                              staticClass: "thumb",
                              attrs: {
                                src: _vm.link.thumb,
                                decoding: "async",
                                alt: "",
                              },
                              on: {
                                error: _vm.onThumbnailError,
                                abort: _vm.onThumbnailError,
                                load: _vm.onPreviewReady,
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "toggle-text", attrs: { dir: "auto" } },
                      [
                        _c("div", { staticClass: "head" }, [
                          _c("div", { staticClass: "overflowable" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.link.link,
                                  title: _vm.link.head,
                                  target: "_blank",
                                  rel: "noopener",
                                },
                              },
                              [_vm._v(_vm._s(_vm.link.head))]
                            ),
                          ]),
                          _vm.showMoreButton
                            ? _c(
                                "button",
                                {
                                  staticClass: "more",
                                  attrs: {
                                    "aria-expanded": _vm.isContentShown,
                                    "aria-label": _vm.moreButtonLabel,
                                    dir: "auto",
                                  },
                                  on: { click: _vm.onMoreClick },
                                },
                                [_c("span", { staticClass: "more-caret" })]
                              )
                            : _vm._e(),
                        ]),
                        _c("div", { staticClass: "body overflowable" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.link.link,
                                title: _vm.link.body,
                                target: "_blank",
                                rel: "noopener",
                              },
                            },
                            [_vm._v(_vm._s(_vm.link.body))]
                          ),
                        ]),
                      ]
                    ),
                  ]
                : _vm.link.type === "image"
                ? [
                    _c(
                      "a",
                      {
                        staticClass: "toggle-thumbnail",
                        attrs: {
                          href: _vm.link.link,
                          target: "_blank",
                          rel: "noopener",
                        },
                        on: { click: _vm.onThumbnailClick },
                      },
                      [
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.link.sourceLoaded,
                              expression: "link.sourceLoaded",
                            },
                          ],
                          attrs: {
                            src: _vm.link.thumb,
                            decoding: "async",
                            alt: "",
                          },
                          on: { load: _vm.onPreviewReady },
                        }),
                      ]
                    ),
                  ]
                : _vm.link.type === "video"
                ? [
                    _c(
                      "video",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.link.sourceLoaded,
                            expression: "link.sourceLoaded",
                          },
                        ],
                        attrs: { preload: "metadata", controls: "" },
                        on: { canplay: _vm.onPreviewReady },
                      },
                      [
                        _c("source", {
                          attrs: {
                            src: _vm.link.media,
                            type: _vm.link.mediaType,
                          },
                        }),
                      ]
                    ),
                  ]
                : _vm.link.type === "audio"
                ? [
                    _c(
                      "audio",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.link.sourceLoaded,
                            expression: "link.sourceLoaded",
                          },
                        ],
                        attrs: { controls: "", preload: "metadata" },
                        on: { canplay: _vm.onPreviewReady },
                      },
                      [
                        _c("source", {
                          attrs: {
                            src: _vm.link.media,
                            type: _vm.link.mediaType,
                          },
                        }),
                      ]
                    ),
                  ]
                : _vm.link.type === "error"
                ? [
                    _vm.link.error === "image-too-big"
                      ? _c("em", [
                          _vm._v(
                            "\n\t\t\t\tThis image is larger than " +
                              _vm._s(_vm.imageMaxSize) +
                              " and cannot be previewed.\n\t\t\t\t"
                          ),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.link.link,
                                target: "_blank",
                                rel: "noopener",
                              },
                            },
                            [_vm._v("Click here")]
                          ),
                          _vm._v(
                            "\n\t\t\t\tto open it in a new window.\n\t\t\t"
                          ),
                        ])
                      : _vm.link.error === "message"
                      ? [
                          _c("div", [
                            _c("em", [
                              _vm._v(
                                "\n\t\t\t\t\t\tA preview could not be loaded.\n\t\t\t\t\t\t"
                              ),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.link.link,
                                    target: "_blank",
                                    rel: "noopener",
                                  },
                                },
                                [_vm._v("Click here")]
                              ),
                              _vm._v(
                                "\n\t\t\t\t\t\tto open it in a new window.\n\t\t\t\t\t"
                              ),
                            ]),
                            _c("br"),
                            _c("pre", { staticClass: "prefetch-error" }, [
                              _vm._v(_vm._s(_vm.link.message)),
                            ]),
                          ]),
                          _c(
                            "button",
                            {
                              staticClass: "more",
                              attrs: {
                                "aria-expanded": _vm.isContentShown,
                                "aria-label": _vm.moreButtonLabel,
                              },
                              on: { click: _vm.onMoreClick },
                            },
                            [_c("span", { staticClass: "more-caret" })]
                          ),
                        ]
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }